import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import validationErrors from '@/lib/validationErrors';
import ToastMe from '@/components/ui/ToastMe';
import Swal from 'sweetalert2';
import { getItemExtraService, deleteItemExtraService } from '@/services/ItemExtraServices';
import AddEditItemExtraModel from './AddEditItemExtraModel';
import DataTableItmExtra from './DataTableItmExtra';

const ExtraTabs = ({ dataSource }) => {
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [editDataId, setEditDataId] = useState('');
    const [itemExtraDataSource, setItemExtraDataSource] = useState([]);
    const [itemExtraTotal, setItemExtraTotal] = useState(0);
    const [openItemExtraModel, setOpenItemExtraModel] = useState(false);
    const [itemExtraFilter, setItemExtraFilter] = useState({
        search: '',
        page: 1,
        limit: 10,
        extra_filter: {},
    });

    useEffect(() => {
        if (dataSource?._id && dataSource?._id != '') {
            getRetryData();
        }
    }, [dataSource?._id]);

    const tableItmExtraColumn = [
        { name: 'Name', isIncludePrint: true },
        { name: 'Price', isIncludePrint: true },
        { name: 'Status', isIncludePrint: true },
        { name: 'Action', isIncludePrint: false },
    ];

    const onChangeItemExtraFilter = (name, value) => {
        setItemExtraFilter({ ...itemExtraFilter, [name]: value });
    };

    const getRetryData = () => {
        getItemAttributesData(dataSource?._id);
    };

    const getItemAttributesData = (itemId) => {
        setIsLoading(true);
        setItemExtraFilter({ ...itemExtraFilter, extra_filter: { item_id: itemId } });

        dispatch(getItemExtraService({ ...itemExtraFilter, extra_filter: { item_id: itemId } }))
            .then((res) => {
                setItemExtraDataSource(res?.data?.data?.data);
                setItemExtraTotal(res?.data?.data?.total);
                setIsLoading(false);
            })
            .catch(({ message, errorData, statusCode }) => {
                validationErrors(errorData, message);
                setIsLoading(false);
            });
    };

    const handleEditOpen = (editId) => {
        if (editId && editId != '') {
            setEditDataId(editId);
        } else {
            setEditDataId('');
        }
        setOpenItemExtraModel(true);
    };

    const deleteRecord = (deleteId) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
                setIsLoading(true);
                dispatch(deleteItemExtraService(deleteId))
                    .then((res) => {
                        Swal.fire({
                            title: 'Deleted!',
                            text: 'Your record has been deleted.',
                            icon: 'success',
                        });
                        getItemAttributesData(dataSource?._id);
                        setIsLoading(false);
                    })
                    .catch(({ message, errorData, statusCode }) => {
                        validationErrors(errorData, message);
                        setIsLoading(false);
                    });
            }
        });
    };

    return (
        <>
            <button type="button" onClick={() => setOpenItemExtraModel(true)} className={'db-btn h-[37px] text-white bg-primary mb-5'}>
                <i className={'lab lab-add-circle-line'}></i>
                Add Extra
            </button>

            <DataTableItmExtra
                isLoading={isLoading}
                tableColumn={tableItmExtraColumn}
                dataSource={itemExtraDataSource}
                totalRecord={itemExtraTotal}
                dataFilter={{
                    search: '',
                    page: 1,
                    limit: 100,
                    extra_filter: { item_id: dataSource?._id },
                }}
                handleEditOpen={handleEditOpen}
                deleteRecord={deleteRecord}
                onChangePage={onChangeItemExtraFilter}
            />
            <AddEditItemExtraModel
                modelTitle={'Item Extra'}
                getTableData={getRetryData}
                openModel={openItemExtraModel}
                setOpenModel={setOpenItemExtraModel}
                editDataId={editDataId}
                itemId={dataSource?._id}
            />
        </>
    );
};

export default ExtraTabs;
